import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import produce from 'immer';
import { toast } from 'react-toastify';

import { Box, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import { SelectCustom } from '../../../../components/Inputs';
import { localesSelector } from '../../../../redux/selectors/SessionData';

const CustomFieldTextEditor = ({ value, handleCustomFieldValueChange }) => {
  const [newLineLanguage, setNewLineLanguage] = useState('');

  const availableLocales = useSelector(localesSelector);

  const usedLocales = Object.keys(value || {});

  const handelAddLocale = () => {
    if (!newLineLanguage) return;

    if (usedLocales.includes(newLineLanguage)) {
      toast.error('Locale already exists!');

      return;
    }

    setNewLineLanguage('');

    handleCustomFieldValueChange(produce(value || {}, (draft) => {
      draft[newLineLanguage] = '';
    }));
  };

  const handleRemoveLocale = (locale) => {
    handleCustomFieldValueChange(produce(value, (draft) => {
      delete draft[locale];
    }));
  };

  const handleNewLineLanguageSelect = ({ target: { value: newValue } }) => setNewLineLanguage(newValue);

  const handleLocalizationChange = (locale) => ({ target: { value: newValue } }) => {
    handleCustomFieldValueChange(produce(value, (draft) => {
      draft[locale] = newValue;
    }));
  };

  return (
    <Box sx={{ display: 'flex', flexFlow: 'column', gap: 3 }}>
      {usedLocales.map((locale) => (
        <Box key={locale} display="flex" alignItems="start">
          <TextField
            fullWidth
            multiline
            label={locale}
            variant="outlined"
            value={value[locale]}
            onChange={handleLocalizationChange(locale)}
          />
          <IconButton sx={{ marginTop: '8px' }} onClick={() => handleRemoveLocale(locale)}>
            <CloseIcon />
          </IconButton>
        </Box>
      ))}
      <Box display="flex" alignItems="center" gap={3} width="300px">
        <SelectCustom
          label="addLanguage"
          value={newLineLanguage}
          wrapText
          selectOptions={availableLocales}
          onChangeSelect={handleNewLineLanguageSelect}
        />
        <IconButton disabled={!newLineLanguage} onClick={handelAddLocale}>
          <AddCircleIcon
            color="primary"
          />
        </IconButton>
      </Box>
    </Box>
  );
};

const { object, func } = PropTypes;

CustomFieldTextEditor.propTypes = {
  value: object,
  handleCustomFieldValueChange: func,
};

CustomFieldTextEditor.defaultProps = {
  value: {},
};

export default CustomFieldTextEditor;
